import { EDITOR_TYPE } from '@wix/wix-data-client-common'
import { createBlankPresetFieldMap as fieldMapForClassic } from './classic/blankPresetFieldMap'
import { createBlankPresetFieldMap as fieldMapForStudio } from './studio/blankPresetFieldMap'
import type { BlankPresetFieldMap } from './types'
import type { Schema } from '@wix/wix-data-schema-types'

const fieldMapByEditorType: Partial<Record<EDITOR_TYPE, BlankPresetFieldMap>> =
  {
    [EDITOR_TYPE.CLASSIC]: fieldMapForClassic,
    [EDITOR_TYPE.STUDIO]: fieldMapForStudio,
  }

export const createBlankPresetFieldMap = ({
  editorType,
  fields,
  itemPageLinkFieldKey,
  indexPageLinkFieldKey,
}: {
  editorType: EDITOR_TYPE
  fields: Schema['fields']
  itemPageLinkFieldKey: string
  indexPageLinkFieldKey: string
}) => {
  const fieldMap = fieldMapByEditorType[editorType] || fieldMapForClassic

  return fieldMap({
    fields,
    itemPageLinkFieldKey,
    indexPageLinkFieldKey,
  })
}
